import { AxiosInstance } from '../../../../utilities/requestClient';
import { uploadFile } from '../../../upload';
import {
  PreTradeCheckerBatchUploadParams,
  PreTradeCheckerBatchUploadResponse,
  PreTradeCheckerParams,
  PreTradeCheckerResponse,
} from './types';

export const getPreTradeCheckerResult = async ({
  fundId,
  positionDate,
  isin,
}: PreTradeCheckerParams): Promise<PreTradeCheckerResponse> => {
  const response = await AxiosInstance.get(
    `pre_trade_checker/${fundId}/${positionDate}/${isin}`,
  );
  return response.data;
};

export const uploadPreTradeCheckerFile = ({
  fundId,
  positionDate,
  file,
  onProgress,
}: PreTradeCheckerBatchUploadParams) =>
  uploadFile<PreTradeCheckerBatchUploadResponse>({
    file,
    onProgress,
    url: `pre_trade_file_upload/${encodeURIComponent(fundId)}/${encodeURIComponent(positionDate)}`,
  });
